import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  VStack,
  Heading,
  Text,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Center,
  Show,
  Box,
} from "@chakra-ui/react";
import { SignupUnit } from "../SignupFlow";
import { Competition_GET } from "../../../../Api/dto/Competition_GET";
import { Discipline_GET } from "../../../../Api/dto/Discipline_GET";
import { PaymentMethodE } from "../../../../Api/dto/Competition_POST_PUT";
import { useNavigate } from "react-router-dom";
import { SignupResponseDto } from "../../../../Api/dto/SignupResponseDtos";
import { SwishPaymentBox } from "../PaymentBox/SwishAutoPaymentBox";
import { ofiEmail } from "../../../foreningen";
import {
  EmailAndDiscountSelector,
  useSubstepGetEmailAndDiscount,
} from "./Step5Substep2EmailAndDiscount";
import {
  PaymentMethodSelector,
  paymentMethodToString,
  useSubstepGetPaymentMethod,
} from "./Step5Substep1PaymentMethod";
import {
  PaymentDetailsFinalizer,
  usePaymentDetailsState,
} from "./Step5Substep3PaymentDetails";
import {
  ButtonInitiatingPaymentOfEmailVerification,
  createSignupRequest,
  useInitiateSignup,
} from "./Step5Substep4InitiateSingup";

export const paymentStatusWaiting = "WAITING";
export const paymentStatusSuccess = "SUCCESS";
export const paymentStatusFail = "FAIL";

export const EMAIL_VERIFICATION_CODE_LENGTH = 6;

const PaymentComponent = (props: {
  competition: Competition_GET;
  disciplines: Discipline_GET[];
  signupUnits: SignupUnit[];
  onPrev: () => void;
}) => {
  const [currentStep, setCurrentStep] = useState(1);

  const navigate = useNavigate();

  const paymentMethodSelectionState = useSubstepGetPaymentMethod();
  const [waitingForNextStep, setWaitingForNextStep] = useState(false);

  const emailSelectionState = useSubstepGetEmailAndDiscount(
    paymentMethodSelectionState.state.paymentMethod !==
      PaymentMethodE.SWISH_AUTO
  );

  const paymentFinalizedDetailsState = usePaymentDetailsState(
    paymentMethodSelectionState.state.paymentMethod
  );

  const [noTurnBack, setNoTurnBack] = useState(false);

  const signupInitiationState = useInitiateSignup(
    emailSelectionState.state.email || ""
  );

  //useEffect(() => {
  //console.log("s1", paymentMethodSelectionState.state);
  //}, [paymentMethodSelectionState.state]);
  //useEffect(() => {
  //console.log("s2", emailSelectionState.state);
  //}, [emailSelectionState.state]);
  //useEffect(() => {
  //console.log("s3", paymentFinalizedDetailsState.state);
  //}, [paymentFinalizedDetailsState.state]);
  //useEffect(() => {
  ////console.log("s4", signupInitiationState.state);
  //}, [signupInitiationState.state]);

  useEffect(() => {
    if (noTurnBack && currentStep <= 3) {
      setNoTurnBack(false);
    }
    if (currentStep == 3) {
      paymentFinalizedDetailsState.modifiers.fetchCostCalculation(
        paymentMethodSelectionState.state.paymentMethod ??
          PaymentMethodE.SWISH_AUTO,
        emailSelectionState.state.discount ?? "",
        props.signupUnits.flatMap((su) => su),
        props.competition.tag ?? ""
      );
    } else if (currentStep == 1) {
      setWaitingForNextStep(false);
      emailSelectionState.modifiers.reset();
      paymentFinalizedDetailsState.modifiers.reset();
      signupInitiationState.modifiers.reset();
    }
  }, [currentStep]);

  return (
    <Modal
      closeOnOverlayClick={false}
      scrollBehavior={"inside"}
      isOpen={true}
      onEsc={() => {}} // Disable closing on ESC key
      closeOnEsc={false}
      size={"full"}
      onClose={() => {
        props.onPrev();
      }}
    >
      <ModalOverlay />
      <ModalContent
        background={"white"}
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <ModalHeader fontSize={{ base: "sm", sm: "md" }}>
          Betala/Slutför anmälan
        </ModalHeader>
        {noTurnBack || <ModalCloseButton />}
        <ModalBody
          scrollBehavior={"auto"}
          scrollSnapType={"block"}
          marginTop={"0px"}
          margin={"20px"}
          overflowY={"auto"}
        >
          <VStack spacing={8} align="flex-start">
            {currentStep > 1 ? (
              <HStack
                onClick={() => {
                  if (!noTurnBack) {
                    setCurrentStep(1);
                  }
                }}
              >
                {" "}
                <Text fontSize={"14px"}>
                  <b>Steg 1:</b> Betalningsmetod: "
                  {paymentMethodToString(
                    paymentMethodSelectionState.state.paymentMethod
                  )}
                  " med avgift {paymentMethodSelectionState.state.fee} kr
                </Text>{" "}
              </HStack>
            ) : (
              currentStep == 1 && (
                <VStack>
                  <Heading size={{ base: "sm", sm: "lg" }}>
                    Steg 1: Betalningsmetod
                  </Heading>

                  <PaymentMethodSelector
                    {...paymentMethodSelectionState}
                    paymentMethods={props.competition.paymentMethods}
                    onSelect={() => setCurrentStep(2)}
                  />
                </VStack>
              )
            )}

            {/***********************************************************************/}
            {currentStep > 2 ? (
              <HStack
                onClick={() => {
                  if (!noTurnBack) {
                    setCurrentStep(2);
                  }
                }}
              >
                {" "}
                <Text fontSize={"14px"}>
                  <b>Steg 2:</b>{" "}
                  {emailSelectionState.state.discount
                    ? `Email: ${emailSelectionState.state.email}\u00A0 \u00A0 \u00A0 Rabattkod: ${emailSelectionState.state.discount}`
                    : `Email: ${emailSelectionState.state.email}`}
                </Text>{" "}
              </HStack>
            ) : (
              currentStep == 2 && (
                <VStack>
                  <Show above="sm">
                    <Heading size={"lg"}>Steg 2: Email och rabattkod</Heading>
                  </Show>
                  <Show below="sm">
                    <Heading size={"sm"}>Steg 2: Email och rabattkod</Heading>
                  </Show>
                  <Center>
                    <EmailAndDiscountSelector
                      {...emailSelectionState}
                      paymentTypeRequiresAuth={
                        paymentMethodSelectionState.state.paymentMethod !==
                        PaymentMethodE.SWISH_AUTO
                      }
                      isInvoice={
                        paymentMethodSelectionState.state.paymentMethod ===
                        PaymentMethodE.INVOICE_MAN
                      }
                    />
                  </Center>

                  <Button
                    hidden={!emailSelectionState.state.valid}
                    onClick={() => {
                      setCurrentStep(3);
                    }}
                  >
                    Nästa
                  </Button>
                </VStack>
              )
            )}

            {/***********************************************************************/}
            {currentStep > 3 ? (
              <HStack
                onClick={() => {
                  if (!noTurnBack) {
                    setCurrentStep(3);
                  }
                }}
              >
                <Text fontSize={"14px"}>
                  <b>Steg 3:</b> Anmälningsavgift totalt:{" "}
                  {paymentFinalizedDetailsState.state.cost} kr
                </Text>{" "}
              </HStack>
            ) : (
              currentStep == 3 && (
                <VStack spacing={"0px"}>
                  <Show above="sm">
                    <Heading size={"lg"}>Steg 3: Betalningsdetaljer</Heading>
                  </Show>
                  <Show below="sm">
                    <Heading size={"sm"}>Steg 3: Betalningsdetaljer</Heading>
                  </Show>
                  <PaymentDetailsFinalizer
                    {...paymentFinalizedDetailsState}
                    paymentMethod={
                      paymentMethodSelectionState.state.paymentMethod
                    }
                  />
                  <ButtonInitiatingPaymentOfEmailVerification
                    isDisabled={
                      !paymentFinalizedDetailsState.state.valid ||
                      waitingForNextStep
                    }
                    isLoading={waitingForNextStep}
                    paymentMethod={
                      paymentMethodSelectionState.state.paymentMethod!
                    }
                    cost={paymentFinalizedDetailsState.state.cost}
                    emailVerificationRequired={
                      emailSelectionState.state.emailVerificationNeeded
                    }
                    initiateEmailVerification={() => {
                      setWaitingForNextStep(true);
                      signupInitiationState.modifiers
                        .initiateEmailVerification()
                        .then(() => {
                          setCurrentStep(4);
                        })
                        .finally(() => setWaitingForNextStep(false));
                    }}
                    sendSingupRequestWithoutEmailVerification={() => {
                      setWaitingForNextStep(true);
                      signupInitiationState.modifiers
                        .sendSignupRequest(
                          props.competition.tag!,
                          createSignupRequest(
                            props.signupUnits,
                            paymentMethodSelectionState.state.paymentMethod!,
                            emailSelectionState.state.discount,
                            paymentFinalizedDetailsState.state
                              .invoiceContactInfo
                          ),
                          paymentFinalizedDetailsState.state.cost
                        )
                        .then((response) => {
                          setNoTurnBack(true);
                          if (
                            response.body?.waitingForPayment &&
                            paymentMethodSelectionState.state.paymentMethod ===
                              PaymentMethodE.SWISH_AUTO
                          ) {
                            setCurrentStep(4);
                          } else {
                            setCurrentStep(5);
                          }
                        })
                        .finally(() => setWaitingForNextStep(false));
                    }}
                  />
                </VStack>
              )
            )}

            {/*******************************TODO: continue here!*/}
            {currentStep > 4 ? (
              <Text fontSize={"14px"}>
                <b>Steg 4:</b> Slutför anmälan
              </Text>
            ) : (
              currentStep == 4 && (
                <VStack>
                  <Show above="sm">
                    <Heading size={"lg"}>Steg 4: Slutför anmälan</Heading>
                  </Show>
                  <Show below="sm">
                    <Heading size={"sm"}>Steg 4: Slutför anmälan</Heading>
                  </Show>
                  {signupInitiationState.state.emailVerificationInitiated ? (
                    <VerifyEmailAndSendSignupRequest
                      email={emailSelectionState.state.email ?? ""}
                      signupResponse={
                        signupInitiationState.state.signupResponse ?? undefined
                      }
                      signupResponseStatusCode={
                        signupInitiationState.state.signupResponseCode
                      }
                      onComplete={() => {
                        navigate(`/tavlingar/${props.competition.tag}`);
                      }}
                      onRestart={() => {
                        setCurrentStep(1);
                      }}
                      triggerSendSignupRequest={(c1: string) => {
                        setNoTurnBack(true);
                        signupInitiationState.modifiers
                          .sendSignupRequestWithVerificationCode(
                            props.competition.tag ?? "",
                            createSignupRequest(
                              props.signupUnits,
                              paymentMethodSelectionState.state.paymentMethod!, /////////////////TODO::::: check here..
                              emailSelectionState.state.discount,
                              paymentFinalizedDetailsState.state
                                .invoiceContactInfo
                            ),
                            c1
                          )
                          .then(() => {
                            // DO something?
                            //setSignupResponse(response.body);
                            ////console.log("Response: ", response);
                            //setSignupResponseStatusCode(response.status);
                          });
                      }}
                    />
                  ) : paymentMethodSelectionState.state.paymentMethod ==
                    PaymentMethodE.SWISH_AUTO ? (
                    <SwishPaymentBox
                      competitionTag={props.competition.tag ?? ""}
                      email={emailSelectionState.state.email ?? ""}
                      signupResponse={
                        signupInitiationState.state.signupResponse ?? undefined
                      }
                      onComplete={() => {
                        navigate(`/tavlingar/${props.competition.tag}`);
                      }}
                      onRestart={() => {
                        setCurrentStep(1);
                      }}
                    />
                  ) : (
                    <Text>
                      Hoppsan något gick fel. Vänligen kontakta {ofiEmail} med
                      felkod "1544"
                    </Text>
                  )}
                </VStack>
              )
            )}

            {currentStep > 5 ? (
              <Text fontSize={"14px"}>
                <b>Steg 5:</b> Anmälan mottagen
              </Text>
            ) : (
              currentStep == 5 && (
                <VStack width={"100%"} align={"center"}>
                  <Show above="sm">
                    <Heading size={"lg"}>Steg 5: Slutför anmälan</Heading>
                  </Show>
                  <Show below="sm">
                    <Heading size={"sm"}>Steg 5: Slutför anmälan</Heading>
                  </Show>
                  {200 <=
                    (signupInitiationState.state.signupResponseCode || -1) &&
                  (signupInitiationState.state.signupResponseCode || -1) <
                    300 ? (
                    <>
                      <Text>
                        Tack! Vi har tagit emot din anmälan och du får snart ett
                        bekräftelsemail.
                      </Text>
                      <Text>Du kan nu stänga sidan.</Text>
                      <Button
                        colorScheme="pink"
                        onClick={() =>
                          navigate(`/tavlingar/${props.competition.tag}`)
                        }
                      >
                        Stäng sidan
                      </Button>
                    </>
                  ) : (
                    <VStack>
                      <Text>{`Någonting gick fel. Kod: ${signupInitiationState.state.signupResponseCode}`}</Text>
                      <Button
                        onClick={() => {
                          setCurrentStep(1);
                        }}
                      >
                        Försök igen
                      </Button>
                    </VStack>
                  )}
                </VStack>
              )
            )}
          </VStack>
        </ModalBody>
        <ModalFooter borderRadius={"0px"} background={"blue.100"}>
          <Spacer />
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

function VerifyEmailAndSendSignupRequest(props: {
  email: string;
  triggerSendSignupRequest: (c1: string) => void;
  signupResponse: SignupResponseDto | undefined;
  signupResponseStatusCode: number | undefined;
  onComplete: () => void;
  onRestart: () => void;
}) {
  const [code1, setCode1] = useState("");

  return (
    <>
      <VStack
        hidden={props.signupResponseStatusCode != null}
        width={"sm"}
        background={"blue.50"}
        rounded="xl"
        border="1px"
        borderColor="gray.300"
        p={4}
      >
        <Text>
          En {EMAIL_VERIFICATION_CODE_LENGTH} tecken lång verifieringskod har
          skickats till {props.email}. Fyll i koden i rutan nedan och klicka dig
          vidare för att skicka in anmälan.
        </Text>
        <HStack>
          <Input
            border={"1px"}
            background={"white"}
            placeholder="Skriv koden här..."
            value={code1}
            fontSize={"2xl"}
            minLength={EMAIL_VERIFICATION_CODE_LENGTH}
            maxLength={EMAIL_VERIFICATION_CODE_LENGTH}
            maxWidth={"md"}
            textAlign={"center"}
            onChange={(e) => {
              setCode1(e.target.value.replaceAll(" ", "") ?? "");
            }}
          />
        </HStack>
        <Button
          marginTop={"20px"}
          padding={2}
          fontSize={"20px"}
          width={"80%"}
          colorScheme="green"
          isDisabled={code1?.length != EMAIL_VERIFICATION_CODE_LENGTH}
          onClick={() => {
            props.triggerSendSignupRequest(code1);
          }}
        >
          Skicka
        </Button>
      </VStack>
      <VStack
        hidden={props.signupResponseStatusCode !== 401}
        width={"sm"}
        background={"pink.200"}
        rounded="xl"
        border="1px"
        borderColor="gray.300"
        p={4}
      >
        <Text>
          Fel kod. Kontrollera att koden är den som skickades till {props.email}{" "}
          och försök igen.
        </Text>
        <Input
          placeholder="Skriv koden här..."
          background={"white"}
          value={code1}
          fontSize={"2xl"}
          minLength={EMAIL_VERIFICATION_CODE_LENGTH}
          maxLength={EMAIL_VERIFICATION_CODE_LENGTH}
          maxWidth={"150px"}
          textAlign={"center"}
          onChange={(e) => {
            setCode1(e.target.value.replaceAll(" ", "") ?? "");
          }}
        />
        <HStack marginTop={"20px"}>
          <Button
            colorScheme="yellow"
            onClick={() => {
              props.onRestart();
            }}
          >
            Ändra email
          </Button>
          <Button
            colorScheme="green"
            isDisabled={code1?.length != EMAIL_VERIFICATION_CODE_LENGTH}
            onClick={() => {
              props.triggerSendSignupRequest(code1);
            }}
          >
            Skicka anmälan
          </Button>
        </HStack>
      </VStack>
      <VStack
        hidden={
          props.signupResponseStatusCode == null ||
          props.signupResponseStatusCode >= 300 ||
          props.signupResponseStatusCode < 200
        }
      >
        <ShowPaymentInstructions
          waitingForPayment={!!props.signupResponse?.waitingForPayment}
          waitingForVerification={
            !!props.signupResponse?.manualVerifyBeforeAdmission
          }
          emailAddress={props.email ?? ""}
        />
        <Button
          colorScheme="green"
          onClick={() => {
            props.onComplete();
          }}
        >
          Återgå till startsidan
        </Button>
      </VStack>
      <VStack
        hidden={
          props.signupResponseStatusCode == null ||
          props.signupResponseStatusCode == 401 ||
          (props.signupResponseStatusCode >= 200 &&
            props.signupResponseStatusCode < 300)
        }
      >
        <Text>
          Anmälan misslyckades med statuskod {props.signupResponseStatusCode}.
          Du är välkommen att försöka igen. Om problemen kvarstår så är du även
          välkommen att kontakta oss på {ofiEmail}, så ska vi försöka hjälpa
          dig.
        </Text>
        <Button
          colorScheme="yellow"
          isDisabled={code1?.length != 4}
          onClick={() => {
            props.onRestart();
          }}
        >
          Försök igen
        </Button>
      </VStack>
    </>
  );
}

function ShowPaymentInstructions(props: {
  waitingForPayment: boolean;
  waitingForVerification: boolean;
  emailAddress: string;
}) {
  if (!props.waitingForPayment) {
    return (
      <Text>
        Tack för din anmälan! Du har ingenting mer att betala bör snart få ett
        bekräftelsemail till {props.emailAddress}. Startlistorna kommer snart
        också att uppdateras med din anmälan.
      </Text>
    );
  } else if (props.waitingForVerification) {
    return (
      <Box
        maxWidth={"md"}
        margin={"10px"}
        padding={"20px"}
        background={"yellow.200"}
        borderRadius={"10px"}
        border={"1px"}
        borderColor={"gray.400"}
        shadow={"xl"}
      >
        <Text>Tack!</Text>
        <Text>
          Vi har tagit emot din anmälan och väntar på din betalning. Ett
          emailmeddelande har skickats till <b>{props.emailAddress}</b> med
          information om hur du genomför din betalning. Startlistorna uppdetaras
          så snart vi har verifierat din betalning.
        </Text>
        <Text fontStyle={"italic"}>
          Vänligen notera att verifieringen görs manuellt, så en viss
          fördröjning är att vänta. Om startlistorna inte uppdaterats inom 2
          dagar efter din betalning så är du välkommen att påminna oss via mail
          till {ofiEmail}.
        </Text>
      </Box>
    );
  } else {
    return (
      <Box
        maxWidth={"md"}
        margin={"10px"}
        padding={"20px"}
        background={"yellow.200"}
        borderRadius={"10px"}
        border={"1px"}
        borderColor={"gray.400"}
        shadow={"xl"}
      >
        <Text textAlign={"center"} fontSize={"xl"}>
          Tack!
        </Text>
        <Text textAlign={"center"} marginTop={"10px"}>
          Vi har tagit emot din anmälan och väntar nu på din betalning.
          Information om hur du slutför din betalning har skickats i ett
          epostmeddelande till <b>{props.emailAddress}</b>.
        </Text>
        <Text marginTop={"10px"} fontStyle={"italic"} textAlign={"center"}>
          NOTERA: Vänligen kolla i din skräppost om du inte hittar mailet i din
          inkorg inom de närmaste minuterna!
        </Text>
      </Box>
    );
  }
}

export default PaymentComponent;
